import React, { useEffect, useRef, useState, useContext } from 'react';
import axios from 'axios';
import SetPage from '../../data/SetPage';
import { Modal, Button, Spinner } from 'react-bootstrap';
import SecurityHeaders from '../../context/SecurityHeaders';
import { AuthContext } from '../../context/AuthContext';
import { useParams } from 'react-router-dom';
import SnackbarToast from '../../components/toasts/SnackbarToast';
import DeleteModal from '../../components/modals/DeleteModal';
import EbookPageItem from './EbookPageItem';
import EbookUploader from './EbookUploader';
import { useDispatch } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ENDPOINT from '../../context/EndPoint';
const EbookPages = () => {
    const dispatch = useDispatch()
    const params = useParams();
    const [pages, setPages] = useState(null);
    const [access, setAccess] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [fullscreenImage, setFullscreenImage] = useState(null);
    const pageRefs = useRef([]);
    const mainContainerRef = useRef(null);
    const { user } = useContext(AuthContext);
    const [bookId, setBookId] = useState(null);
    // Fetch pages from the API with error and loading handling
    const fetchPages = async () => {
        dispatch({type:'LOADING'})
        setLoading(true);
        setError(null);
        try {
            const formData = new FormData();
            formData.append('book_name', params.book_name);
            if (user && user.SessionId) {
                formData.append('session', user.SessionId);

            }
            const res = await axios.post("https://siliconmindstechnologies.com/get-pages.php", formData, SecurityHeaders);
            if (res.data.status === "success") {
                dispatch({type:'DONE_LOADING'})
                setPages(res.data.data);

            } else {
                setPages(null);
                dispatch({type:'ERROR',payload:res.data.message})
            }
        } catch (err) {
            dispatch({type:'ERROR', payload:err.message})
            setError("Error fetching pages.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setBookId(params.id);

        SetPage("Book");
        fetchPages();
    }, [params.book_name]);

    // Function to scroll smoothly to a specific page
    const scrollToPage = (index) => {
        setCurrentPage(index);
        if (pageRefs.current[index]) {
            pageRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    // Automatically update the current page as the user scrolls using IntersectionObserver
    useEffect(() => {
        if (!pages || !mainContainerRef.current) return;
        const observerOptions = {
            root: mainContainerRef.current,
            threshold: 0.5
        };
        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const index = parseInt(entry.target.getAttribute('data-index'), 10);
                    setCurrentPage(index);
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        pageRefs.current.forEach((ref, index) => {
            if (ref) {
                ref.setAttribute('data-index', index);
                observer.observe(ref);
            }
        });

        return () => {
            observer.disconnect();
        };
    }, [pages]);

    // console.log(params);
    // Enable keyboard navigation with arrow keys
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!pages) return;
            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                if (currentPage < pages.length - 1) {
                    scrollToPage(currentPage + 1);
                }
            } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                if (currentPage > 0) {
                    scrollToPage(currentPage - 1);
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [currentPage, pages]);

    // Open fullscreen modal for the selected image
    const openFullscreen = (imageUrl) => {
        setFullscreenImage(imageUrl);
    };

    const closeFullscreen = () => {
        setFullscreenImage(null);
    };
    const [open, setOpen] = useState({
        open: false,
        message: '',
        type: ''

    });
    const [modelShow, setModelShow] = useState(false);
    const onDragEnd = async (result) => {
        if (!result.destination) return;
    
        const reorderedPages = Array.from(pages);
        const [movedPage] = reorderedPages.splice(result.source.index, 1);
        reorderedPages.splice(result.destination.index, 0, movedPage);
        setPages(reorderedPages);
    
        const formData = new FormData();
        formData.append('session', user.SessionId);
        formData.append('book_id', bookId);
        formData.append('pages', JSON.stringify(
            reorderedPages.map((p, idx) => ({ id: p.id, page_no: idx + 1 }))
        ));
    
        const res = await axios.post(ENDPOINT+"update-page-order.php", formData, SecurityHeaders);
    
        if (res.data.status !== 'success') {
            console.error('Order update failed', res.data.message);
            fetchPages(); // fallback to original order
        }
    }
    return (
        <>
            <SnackbarToast open={open} handleClose={() => setOpen((pre) => ({ ...pre, open: false }))} />


            <Modal show={modelShow} onHide={() => setModelShow(false)}>
                <Modal.Body>
                    <EbookUploader reload={fetchPages} handelClose={() => setModelShow(false)} bookId={bookId} />
                </Modal.Body>
            </Modal>
            <div className='d-flex justify-content-end container my-4'>
                <button className="btn btn-primary " onClick={() => setModelShow(true)}>
                    Add Page
                </button>

            </div>
            {access ? (
                <div className="container vh-90 d-flex p-0">

                    {loading ? (
                        <div className="text-center mt-5 pt-5">
                            <Spinner animation="border" role="status" />
                            <p>Loading pages...</p>
                        </div>
                    ) : pages ? (
                        <>
                            {/* Thumbnails Sidebar */}
                            <div className="d-none d-md-block col-lg-3 p-2 vh-80 pt-2">
                                <div className="overflow-y bg-white book-thumbnails" style={{ overflowY: 'auto' }}>
                                <DragDropContext onDragEnd={onDragEnd}>
    <Droppable droppableId="pages-list">
        {(provided) => (
            <div
                className="overflow-y bg-white book-thumbnails"
                style={{ overflowY: 'auto' }}
                {...provided.droppableProps}
                ref={provided.innerRef}
            >
                {pages.map((item, index) => (
                    <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                        {(provided) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={() => scrollToPage(index)}
                                style={{ cursor: 'pointer', ...provided.draggableProps.style }}
                                className="mb-2"
                            >
                                <div className="rounded">
                                    <img
                                        className={`col-12 w-100 border rounded ${
                                            currentPage === index ? "border-2 shadow shadow-primary border-primary" : "border-1 border-secondary"
                                        }`}
                                        src={item.image_url}
                                        alt={`Page ${item.page_no}`}
                                        loading="lazy"
                                    />
                                </div>
                                <p className={`m-0 p-0 text-center ${currentPage === index ? "font-weight-bold" : ""}`}>
                                    Page: {index + 1}
                                </p>
                            </div>
                        )}
                    </Draggable>
                ))}
                {provided.placeholder}
            </div>
        )}
    </Droppable>
</DragDropContext>

                                </div>
                            </div>

                            {/* Main Pages Container */}
                            <div
                                className="flow book-pages bg-transparent overflow-y col-12 col-lg-9 vh-100"
                                style={{ overflowY: 'auto' }}
                                ref={mainContainerRef}
                            >
                                {pages.map((item, index) => (
                                    <div key={index} onClick={() => scrollToPage(index)} ref={(el) => (pageRefs.current[index] = el)}>
                                        <EbookPageItem item={item} reload={fetchPages} openFullscreen={openFullscreen} />
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <div className="min-vh-90">
                            <div className="text-center  pt-5 mt-5 col-12">
                                <h4 className='text-center' >Add Pages</h4>

                            </div>
                        </div>
                    )}
                    {error && <div className="alert alert-danger">{error}</div>}
                </div>
            ) : (
                <div className="text-center mt-5 pt-5">Access not permitted.</div>
            )}

            {/* Fullscreen Modal */}
            {fullscreenImage && (
                <Modal show={true} onHide={closeFullscreen} size="lg" centered>
                    <Modal.Body className="p-0">
                        <img src={fullscreenImage} alt="Fullscreen view" className="w-100" />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeFullscreen}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
};

export default EbookPages;
